import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import AppBar from '../../components/AppBar'
import ServiceMenuItem from './ServiceMenuItem'
import { fetchServiceStations } from '../../actions/remote_api'
import { switchStation } from '../../actions/station'
import storage from '../../storage'

class MenuScene extends React.Component {
  componentDidMount() {
    const { fetchServiceStations } = this.props
    fetchServiceStations()
  }

  handleServiceClick = (serviceStation) => {
    const hasOneStation = serviceStation.stations.length === 1
    const station = serviceStation.stations[0]
    const serviceId = station ? station.serviceId : undefined
    storage.clearInfo()
    storage.saveInfo(
      hasOneStation && station && serviceId
        ? {
            serviceId,
            serviceName: serviceStation.name,
            serviceClass: station.serviceClass,
            serviceDisplayName: station.serviceDisplayName,
            stationId: station.id,
            stationName: station.name,
          }
        : {
            serviceId,
            serviceName: serviceStation.name,
          },
    )
    const { stationId } = storage.info()
    this.props.switchStation({ serviceId, stationId: stationId || undefined })
    this.props.history.push(hasOneStation ? '/checkin' : '/stations')
  }

  render() {
    const { serviceStations } = this.props
    return (
      <div className="min-h-screen bg-gray-50">
        <AppBar header="INTERNAL MANAGEMENT SYSTEMS" />

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {(serviceStations || []).map((service) => (
              <ServiceMenuItem
                key={service.name}
                service={service}
                onServiceClick={this.handleServiceClick}
              />
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(
  connect(
    ({ fetch }) => ({
      serviceStations: fetch.serviceStation
        ? fetch.serviceStation.list
        : undefined,
    }),
    { fetchServiceStations, switchStation },
  )(MenuScene),
)
